import { useState, type ReactNode } from "react";

export function useCollectionsLayoutContextValue() {
  const [center, setCenter] = useState<ReactNode>(null);
  const [trailing, setTrailing] = useState<ReactNode>(null);

  return { center, setCenter, setTrailing, trailing };
}

export type CollectionsLayoutContextValue = ReturnType<typeof useCollectionsLayoutContextValue>;
